// src/components/Loader/LogoLoader.js
import "./Loader.scss";
// import Logo from "/img/fallBack.jpg"; // prilagodi putanju

export default function LogoLoader() {
  return (
    <div className="logo-loader-wrapper">
      <img src={"/img/fallBack.jpg"} alt="Agroweb logo loading" className="logo-spinner" />
    </div>
  );
}
